import { useCallback, useEffect, useState } from "react";
import useFetch from "./useFetch";
import usePost from "./usePost";
import useCurrent from "./useCurrent";


const useLicense = (withCreate=true) =>{
    const {currentTenantId:tenantId} = useCurrent();
    const token = localStorage.getItem('token');
    const shouldFetch = Boolean(tenantId && token);
    const licenseUrl = shouldFetch
        ? `${process.env.REACT_APP_Auth_API_BASE_URL}/licenses/tenant/${tenantId}`
        : null;
    const {data,loading,error} = useFetch(licenseUrl, shouldFetch);
    const {data:resultPost,postData} = usePost();
    const [isCreated,setIsCreated] = useState(false);

    const TRAIL_PERIOD_DAYS = 14;
    const [licenseDays,setLicenseDays] = useState(TRAIL_PERIOD_DAYS);
    const [typeLicense , setTypeLicense] = useState('Trail');

    const createLicense = useCallback(() =>{
        if (!tenantId) return;
        const date = new Date();
        const startDate = new Date();
        const endDate = new Date(date.setDate( date.getDate() + 14 ))
        const _data = {
            tenantId: tenantId,
            companiesCount:1,
            branchesCount:1,
            usersCount:1,
            appIds: ['SALES'] ,
            typeLicense:'Trail',
            startDate: startDate,
            endDate:  endDate,
        };
        postData(`${process.env.REACT_APP_Auth_API_BASE_URL}/licenses`,_data)
        setIsCreated(true)
    }, [postData, tenantId])

    useEffect(() => {
        if(resultPost){
            console.log('License Created Success')
        }
    },[resultPost]);

    useEffect(()=>{
        if (!data || !Array.isArray(data.data)) return;

        if (data.data.length === 0) {
            if (!isCreated && withCreate) createLicense();
            return;
        }

        const license = data.data[0];
        if (!license) return;

        if (license.typeLicense) {
            setTypeLicense(license.typeLicense);
        }

        if (license.endDate) {
            const daysDiff = Math.abs(new Date() - new Date(license.endDate));
            if (daysDiff) {
                setLicenseDays(Math.round(daysDiff / 86400000));
            }
        }
    },[createLicense, data, isCreated, withCreate]);

    useEffect(() => {
        if (error?.response?.status === 403) {
            setTypeLicense('Trail');
            setLicenseDays(TRAIL_PERIOD_DAYS);
        }
    }, [error]);

    return {data,loading,licenseDays,TRAIL_PERIOD_DAYS,typeLicense}
} 


export default useLicense;
